import { ORDER_DEPRECIATION_SETTINGS_V2_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetOrderDepreciationSettingsV2APIError,
  GetOrderDepreciationSettingsV2APIVariables,
  fetchGetOrderDepreciationSettingsV2API,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = ORDER_DEPRECIATION_SETTINGS_V2_API.GET;

export const useGetOrderDepreciationSettingsV2API = (
  variables: GetOrderDepreciationSettingsV2APIVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetOrderDepreciationSettingsV2APIError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetOrderDepreciationSettingsV2APIError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetOrderDepreciationSettingsV2APIError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/depreciationSettingsV2',
      operationId: 'getOrderDepreciationSettingsV2API',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetOrderDepreciationSettingsV2API({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
